import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import {
    ContactSection, BadgeListSection, SocialSection,
    AboutSection, ExperienceSection, EducationSection, ReferencesSection,
} from './PdfSections';

const styles = StyleSheet.create({
    page: { padding: 30, fontSize: 10, fontFamily: 'Helvetica', backgroundColor: '#F5F5EF' },
    name: { fontSize: 20, fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase' },
    role: { fontSize: 12, textAlign: 'center', textTransform: 'uppercase', marginBottom: 14 },
});

function Template12Pdf(props) {
    const {
        name, about, email, address, phone, title,
        technicalSkills, languages, softSkills,
        linkedinURL, twitterURL, websiteURL,
        educationData, jobData, showSocial, referenceData,
    } = props;

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <Text style={styles.name}>{name}</Text>
                <Text style={styles.role}>{title}</Text>
                <AboutSection about={about} />
                <ContactSection email={email} phone={phone} address={address} />
                <SocialSection linkedinURL={linkedinURL} twitterURL={twitterURL} websiteURL={websiteURL} showSocial={showSocial} />
                <BadgeListSection title="Professional Skills" items={technicalSkills} />
                <BadgeListSection title="Soft Skills" items={softSkills} />
                <BadgeListSection title="Languages Known" items={languages} />
                <ExperienceSection jobData={jobData} />
                <EducationSection educationData={educationData} />
                <ReferencesSection referenceData={referenceData} />
            </Page>
        </Document>
    );
}

export default Template12Pdf;